export const features = {
  countdown: false,
  followerBar: true,
  isPresale: false,
  isProd: true,
  mintBar: false,
  mintButton: false,
}